import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../../shared/Carousel';
import {getSafeTranslations} from '../../../utils/hitLabels';
import DestinationCard from '../Cards/DestinationCard';
import {isNegativeMinCount, isContainsData} from '../../shared/helpers';
import {filterDestinationHits} from '../../../utils/hitLabels';
import {get} from '../../../utils/helpers';
import {CAROUSEL_TYPES} from '../../../utils/edap/edapEventsConstants';
function DestinationCarousel(props) {
    const {
        actionLocation,
        aspectRatio,
        breakpoints,
        cardLinkTarget,
        cardSizeSm,
        customCardClickHandler,
        isMobile,
        isNextGeoLevel,
        layoutAlignment,
        minDestinationCount,
        onCardsShownChange,
        propertyViewEventFirePosition,
        data,
        scrolling,
        scrollMarginOffset,
        subtitle,
        target,
        title,
    } = props;

    if (isContainsData(data)) return null;

    const {clientRequestId, recommendedDestinations} = data;
    const {nextButtonLabel, prevButtonLabel} = getSafeTranslations();
    const getDestinationCards = (recommendedHits) => {
        if (
            isNegativeMinCount(minDestinationCount) ||
            recommendedHits.length < minDestinationCount
        ) {
            return null;
        }
        return recommendedHits.map((hit, position) => {
            const breadcrumbsFirstLevelSimple = get(
                hit,
                'breadcrumbs[0].place.name.simple'
            );
            const place = get(hit, 'place.name.simple');
            const breadcrumbsNextLevelSimple =
                isNextGeoLevel && get(hit, 'breadcrumbs[1].place.name.simple');
            const placeNameSimple = place || breadcrumbsFirstLevelSimple;

            return (
                <DestinationCard
                    {...hit}
                    title={placeNameSimple}
                    actionLocation={actionLocation}
                    aspectRatio={aspectRatio}
                    cardIndex={position + 1}
                    clientRequestId={clientRequestId}
                    target={target}
                    cardLinkTarget={cardLinkTarget}
                    key={`destinations-${position}`}
                    customCardClickHandler={customCardClickHandler}
                    subtitle={breadcrumbsNextLevelSimple}
                />
            );
        });
    };

    const destinationHits = filterDestinationHits(recommendedDestinations);
    const cards = getDestinationCards(destinationHits);

    return (
        <Carousel
            carouselType={CAROUSEL_TYPES.DESTINATION}
            cards={cards}
            hits={destinationHits}
            subheading={subtitle}
            translations={{
                nextButtonLabel,
                prevButtonLabel,
            }}
            {...{
                actionLocation,
                aspectRatio,
                breakpoints,
                title,
                cards,
                cardSizeSm,
                clientRequestId,
                isMobile,
                layoutAlignment,
                onCardsShownChange,
                propertyViewEventFirePosition,
                scrolling,
                scrollMarginOffset,
                target,
            }}
        />
    );
}

DestinationCarousel.propTypes = {
    aspectRatio: PropTypes.string,
    breakpoints: PropTypes.objectOf(PropTypes.number),
    className: PropTypes.string,
    cardLinkTarget: PropTypes.string,
    cardSizeSm: PropTypes.bool,
    customCardClickHandler: PropTypes.func,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    isNextGeoLevel: PropTypes.bool,
    layoutAlignment: PropTypes.oneOf([
        'container',
        'cards',
        'cardsWithOverlapButtons',
        'buttons',
    ]),
    propertyViewEventFirePosition: PropTypes.oneOf(['top', 'bottom', 'onload']),
    onCardsShownChange: PropTypes.func,
    minDestinationCount: PropTypes.number,
    data: PropTypes.shape({
        recommendedDestinations: PropTypes.arrayOf(
            PropTypes.shape({
                destinationUrl: PropTypes.string,
                imageHref: PropTypes.string,
                searchTermUuid: PropTypes.string,
                recommendedDestinations: PropTypes.arrayOf(
                    PropTypes.shape({
                        destinationUrl: PropTypes.string,
                        imageHref: PropTypes.string,
                        searchTermUuid: PropTypes.string,
                        place: PropTypes.shape({
                            name: PropTypes.shape({
                                simple: PropTypes.string,
                                full: PropTypes.string,
                            }),
                        }),
                        breadcrumbs: PropTypes.arrayOf(
                            PropTypes.shape({
                                place: PropTypes.shape({
                                    name: PropTypes.shape({
                                        simple: PropTypes.string,
                                        full: PropTypes.string,
                                    }),
                                }),
                            })
                        ),
                    })
                ),
            })
        ),
        clientRequestId: PropTypes.string.isRequired,
    }),
    scrolling: PropTypes.bool,
    scrollMarginOffset: PropTypes.number,
    subheading: PropTypes.string,
    subLocation: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default DestinationCarousel;
